<template>
  <v-container fluid grid-list-lg grid-list-md v-if="stepper">
    <v-stepper v-model="e1" elevation="0">
      <v-stepper-header>
        <template v-for="(item, index) in stepper.steps">
          <v-stepper-step  :complete="e1 > index+1" :step="index+1" @click="e1 = index+1; save(index, false);" :color="stepper.color.complete">{{ item.name }} </v-stepper-step>
          <v-divider v-if="index < stepper.steps.length"></v-divider>
        </template>
      </v-stepper-header>
      <v-stepper-items>
        <template v-for="(item, index) in chart.domain.content.steps">
          <v-stepper-content :step="index+1">
            <v-layout row wrap>
              <v-flex xs12>
                <dynamic-detail :details="item.details" :chart="chart" :stepper="chart.domain.content" :key="index" :detailIndex="index" />
              </v-flex>
            </v-layout>
            <v-btn :color="button.color.default" @click="save(index, true, index+2)" dark>
              {{ item.next }}
            </v-btn>
            <v-btn flat>Cancel</v-btn>
          </v-stepper-content>
        </template>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>
<script>

import {
  createNamespacedHelpers
}
from 'vuex';

const {
  mapState, mapActions, mapGetters, mapMutations
} = createNamespacedHelpers('users');

import {
  upsertContent, getContent, createContent
}
from '@/models/freedomain';

let freeDomain = createContent();
const formColumns = ["id", "name", "description", "foreign_id", "status", "open_id", "open_code"];
import DynamicDetail from '@/components/charts/form/dynamic-form/detail.vue';

export default {
  props: ['chart'],
  data: () => ({
    foreignKey: null,
    e1: 0,
    stepper: null,
    button: {
      color: {default: 'purple'}
    },
}),
components: {
  'dynamic-detail': DynamicDetail
},
methods: {
  updateValues() {
    try {
      this.stepper = this.chart.domain.content;
      this.e1 = this.stepper.position;
    } catch(err) {

    }
  },
  next(index) {
    if(index+1 < this.stepper.steps.length) {
      this.e1 = index+2;
    }
  },
  save(index, next, position) {

    if(typeof next == "undefined" || next != false) {
        this.next(index);
    }
    this.stepper.stepIndex = index;
    if(typeof position != "undefined") {
      this.stepper.position = position;
    } else {
      this.stepper.position = index+1;
    }

    this.stepper.positionName = this.stepper.steps[this.e1].name;
    this.stepper.totalSteps = this.stepper.steps.length;
    this.setGlobalValues();
    this.chart.save(this.stepper);
    console.log("this.after save main", this.stepper);

  },
  setGlobalValues() {
    this.chart.fn.setGlobalValues(this.stepper, this.chart);

    console.log("this.stepper main", this.stepper);
  },
  setStepGlobalValues(step) {
    try {
      for(let i = 0; i < step.details.rows.length; i++) {
        this.setRowGlobalValues(step.details.rows[i], step.id);
      }
    } catch(err) {

    }
  },
  setRowGlobalValues(row, id) {
    for(let i = 0; i < row.elements.length; i++) {
      this.setElementGlobalValues(row.elements[i], id);
    }
  },
  setElementGlobalValues(element, id) {
    try {
      if(typeof this.stepper.values == "undefined") {
        this.stepper.values = {};
      }
      if(typeof element.name != "undefined") {
        const key = id + "_" + element.name;
        if(typeof this.stepper.values[key] != "undefined") {

        }
        this.stepper.values[key] = element.model;
      }

      if(typeof element.globalName != "undefined") {
        if(formColumns.includes(element.globalName)) {
          this.chart.domain[element.globalName] = element.model;
        }
      }

    } catch(err) {

    }
  },
  appendRows(rows, index) {
    let row = this.nullifyElements(rows[index]);
    rows.splice(index, 0, row);
  },
  nullifyElements(row) {
    let r = {...row};
    for (let i = 0; i < r.elements.length; i++) {
      r.elements[i].model = null;
    }
    return r;
  }
},
async mounted() {
  console.log("this.chart", this.chart);
  this.updateValues();
  this.chart.$el = this;


  //  this.
  // if(this.chart.data.id) {
  //   this.freeDomain = await getContent(this.chart.data.table, this.chart.data.id);
  //   //stepper
  // } else {
  //   freeDomain.content = Object.assign({...this.stepper});
  //   this.freeDomain = await upsertContent(table, this.freeDomain);
  // }
  // this.$validator.localize('en', this.dictionary);
  }
}

</script>
